import Header from './header'

const SmartSearchEmptyCase = () => {
  return (
    <div className="min-h-[252px]">
      <Header />
      <div className="mt-4 flex flex-col items-center justify-center lg:mt-5">
        <img
          src={`${import.meta.env.VITE_STATIC_RES}/img/no_results_dog.webp`}
          alt="no_results"
          width={138}
          height={130}
        />
        <div className="mb-3 mt-5 text-primary-600 text-headline-3">No matches found</div>
        <p className="whitespace-pre-line text-center text-primary-600 text-body-2 lg:text-body-3">
          {`Your pet seems to have a unique issue.\nWe haven’t experienced this yet.`}
        </p>
      </div>
    </div>
  )
}

export default SmartSearchEmptyCase
